import React from 'react';

import { getZonedDate } from '@eika-infrastruktur/date';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { useConfig } from '../../defaultConfig';
import useTranslation from '../../hooks/useTranslation';

import './NoTasksCard.scss';

type Props = {
    age?: number;
};

const today = getZonedDate();

const easterMonths = [3];
const autumnMonhts = [8, 9, 10];
const winterMonths = [0, 1, 2, 11];

type Seasons = 'summer' | 'winter' | 'autumn' | 'easter';

const getSeasonFromMonth = (): Seasons => {
    const monthNumber = today.getMonth();
    if (easterMonths.includes(monthNumber)) {
        return 'easter';
    }
    if (autumnMonhts.includes(monthNumber)) {
        return 'autumn';
    }
    if (winterMonths.includes(monthNumber)) {
        return 'winter';
    }

    return 'summer';
};

const getRichIconFromMonth = (enabled = true) => {
    if (!enabled) return RichIconTypes.PARK_M_FUGL;
    const season = getSeasonFromMonth();
    switch (season) {
        case 'winter':
        case 'easter':
            return RichIconTypes.HYTTE;
        case 'summer':
        case 'autumn':
        default:
            return RichIconTypes.PARK_M_FUGL;
    }
};

const NoTasksCard: React.FC<Props> = () => {
    const translated = useTranslation();
    const { featureToggles } = useConfig();
    return (
        <div className="no-tasks-card">
            <div className="no-tasks-card__icon-wrapper">
                <RichIcon
                    type={getRichIconFromMonth(featureToggles.enableSillyTaskManagerEmptyState)}
                    className="no-tasks-card__icon"
                />
            </div>
            <h3 className="no-tasks-card__title">{translated.taskManager.emptyState}</h3>
            <span className="no-tasks-card__description">{translated.taskManager.noTasks}</span>
        </div>
    );
};

export default NoTasksCard;
